// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const useStyles = () => ({
  button: {
    padding: '6px',
  },
  popover: {
    pointerEvents: 'none',
  },
  popoverText: {
    width: '240px',
    padding: '8px 22px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3px',
  },
  popoverTextLine: {
    fontSize: '13px',
  },
});

export default useStyles;
